module.exports = __webpack_public_path__ + "img/product_banner_img.dc3a4259.gif";